import React, { useState, useEffect} from "react";
import "./Forecast.css";
import axios from "axios";
import WeatherForecastDay from "./WeatherForecastDay";


export default function WeatherForecast(props) {
let [loaded, setLoaded]=useState(false);
let [forecast, setForecast]=useState(null);

useEffect(()=>{
    setLoaded(false);
}, [props.coordinates]);


    function handleResponse(response) {
setForecast(response.data.daily);
setLoaded(true);
        
    }


if (loaded) {
return(
     <div className="row">
        <div className="col">
<WeatherForecastDay data={forecast[0]} />
</div>
 <div className="col">
<WeatherForecastDay data={forecast[1]} />
</div>
 <div className="col">
<WeatherForecastDay data={forecast[2]} />
</div>
 <div className="col">
<WeatherForecastDay data={forecast[3]} />
</div>
 <div className="col">
<WeatherForecastDay data={forecast[4]} />
</div>
</div>
);
}
    else {

let apiKey="e8to4a8c7230336a2148815f4516b5f1";
let lon= props.coordinates.longitude;
let lat= props.coordinates.latitude;
let apiUrl= `https://api.shecodes.io/weather/v1/forecast?lat=${lat}&lon=${lon}&key=${apiKey}&units=metric`;
axios.get(apiUrl).then(handleResponse);

    return null; 
}
}